/**
 * Draft state shared by the text-like fields: while the user edits, the field shows its own draft; the draft is
 * committed on Enter / blur (callers decide what is valid) and dropped on Escape, after which the field shows the
 * value from props again. A field that is not being edited always mirrors its props.
 */

import { useState } from 'react';

export interface Draft {
  /** The text being edited, or null when the field shows its value. */
  readonly text: string | null;
  set(text: string): void;
  clear(): void;
}

export function useDraft(): Draft {
  const [text, setText] = useState<string | null>(null);
  return {
    text,
    set: setText,
    clear: () => {
      setText(null);
    },
  };
}
